var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDurationMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,2C11.8691406,2,2,11.8691406,2,24s9.8691406,22,22,22s22-9.8691406,22-22S36.1308594,2,24,2z M24,44 C12.9716797,44,4,35.0283203,4,24S12.9716797,4,24,4s20,8.9716797,20,20S35.0283203,44,24,44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,16h-2v8c0,1.1025391,0.8974609,2,2,2h10v-2H24V16z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.25,11.442627c0.7174683,0.4141846,1.6348267,0.168396,2.0490112-0.5490723 C33.7132568,10.1761475,33.4674683,9.258728,32.75,8.8445435c-0.7174683-0.4142456-1.6348267-0.168396-2.0490112,0.5490112 C30.2867432,10.1110229,30.5325317,11.0283813,31.25,11.442627z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6063843,17.2990112c0.7174683-0.4141846,0.9632568-1.331604,0.5490723-2.0490112 c-0.4142456-0.7174683-1.331604-0.9632568-2.0490723-0.5490723c-0.7174072,0.4142456-0.9632568,1.331604-0.5490112,2.0490723 C36.9715576,17.4674072,37.8889771,17.7132568,38.6063843,17.2990112z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 24,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6063843,30.7009277c-0.7174072-0.4141846-1.6348267-0.168396-2.0490112,0.5490723 c-0.4142456,0.7174072-0.168396,1.6348267,0.5490112,2.0490112c0.7174683,0.4142456,1.6348267,0.168396,2.0490723-0.5490112 C39.5696411,32.0325317,39.3238525,31.1151733,38.6063843,30.7009277z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.25,36.557373c-0.7174683,0.4141846-0.9632568,1.331604-0.5490112,2.0490112 c0.4141846,0.7174683,1.331543,0.9632568,2.0490112,0.5490723c0.7174683-0.4142456,0.9632568-1.331604,0.5490112-2.0490723 C32.8848267,36.3889771,31.9674683,36.1431274,31.25,36.557373z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 40,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.75,36.557373c-0.7174683-0.4142456-1.6348267-0.168396-2.0490112,0.5490112 c-0.4142456,0.7174683-0.168457,1.6348267,0.5490112,2.0490723c0.7174683,0.4141846,1.6348267,0.168396,2.0490112-0.5490723 C17.7132568,37.8889771,17.4674683,36.9715576,16.75,36.557373z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3936157,30.7009277C8.6761475,31.1151733,8.4303589,32.0325317,8.8445435,32.75 c0.4142456,0.7174072,1.331604,0.9632568,2.0490723,0.5490112c0.7174072-0.4141846,0.9632568-1.331604,0.5490112-2.0490112 C11.0284424,30.5325317,10.1110229,30.2867432,9.3936157,30.7009277z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 24,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8936157,14.7009277C10.1761475,14.2867432,9.2587891,14.5325317,8.8445435,15.25 c-0.4141846,0.7174072-0.168396,1.6348267,0.5490723,2.0490112c0.7174072,0.4142456,1.6348267,0.168396,2.0490112-0.5490112 C11.8568726,16.0325317,11.6110229,15.1151733,10.8936157,14.7009277z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25,8.8445435c-0.7174683,0.4141846-0.9632568,1.331604-0.5490112,2.0490112 c0.4141846,0.7174683,1.331543,0.9632568,2.0490112,0.5490723c0.7174683-0.4142456,0.9632568-1.331604,0.5490112-2.0490723 C16.8848267,8.6761475,15.9674683,8.4302979,15.25,8.8445435z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDurationMedium);
export default __webpack_public_path__ + "static/media/duration--medium.f26fd9ef56a3a47690a7865771b4ca44.svg";
export { ForwardRef as ReactComponent };